
const state = () => ({
  productList: ["1000", "1001", "1002", "1100"], 
  productTypes: ["mask", "cream"], 
  products: {
    "1000": {
      name: "Reture Mask", 
      cnName: "返本賦原全效面膜 ", 
      price: 3600, 
      type: "mask", 
      images: ["info.001.jpeg", "info.002.jpeg", "info.003.jpeg", "info.004.jpeg", "info.005.jpeg", "info.006.jpeg", "info.007.jpeg", "info.008.jpeg"], 
      description: "<b>全方位 / Comprehensive / 重返青春容顏</b><br><br><b>/返本賦原適用對象/</b><br>適用於各種膚質<br><br>用途：瞬效導入技術，瞬間滲入肌膚，輕鬆滲透肌底補水，持久水潤，賦活更新、重現彈潤，散發青春光彩。 ", 
      inCart: 2
    }, 
    "1001": {
      name: "Moisturizing Mask", 
      cnName: "有夠濕面膜", 
      price: 1500, 
      type: "mask", 
      images: ["info.001.jpeg", "info.002.jpeg", "info.003.jpeg", "info.004.jpeg", "info.005.jpeg", "info.006.jpeg", "info.007.jpeg", "info.008.jpeg"], 
      description: "<b>保濕 / Moisturizing / 消除負面能量</b><br><br><b> /有夠濕適用對象/</b><br> 適用於各種膚質<br><br>用途：瞬效導入技術，瞬間滲入肌膚，輕鬆滲透肌底補水，持久水潤，賦活更新，散發青春光彩。", 
      inCart: 3
    }, 
    "1002": {
      name: "Whitening Mask", 
      cnName: "有夠白面膜", 
      price: 1600, 
      type: "mask", 
      images: ["info.001.jpeg", "info.002.jpeg", "info.003.jpeg", "info.004.jpeg", "info.005.jpeg", "info.006.jpeg", "info.007.jpeg", "info.008.jpeg"], 
      description: "<b>亮白 / Whitening / 創造保護結界</b><br><br><b> /有夠白適用對象/</b><br>適用於各種膚質<br><br>用途：瞬效導入技術，瞬間滲入肌膚，使肌膚淨白無瑕、增加透亮光澤感，賦活更新、散發青春光彩。", 
      inCart: 0
    }, 
    "1100": {
      name: "Moisturizing Cream", 
      cnName: "有夠嫩精萃乳霜", 
      price: 2200, 
      type: "cream", 
      images: ["info.001.jpeg", "info.002.jpeg", "info.003.jpeg", "info.004.jpeg", "info.005.jpeg"],
      description: "具備三大美麗的能力，賦活肌膚能量，散發透亮光采，同時保濕鎖水，支援肌膚補充水分並維持細胞最大含水量，讓肌膚維持最佳狀態。 <br><br><b>/有夠嫩適用對象/</b><br> 柔嫩細緻的好吸收凝乳質地，適用於各種膚質。 <br><br><b>/有夠嫩使用方式/</b><br>將有夠嫩精萃乳霜作為保養程序的最後一步，有效加強先前保養精華吸收並鎖住，形成天然屏障，使肌膚均勻透亮、澎潤且柔嫩。容光煥發，明亮淨透！", 
      inCart: 0
    }
  } 
})

const getters = {
  getProductsInCart: (state) => {
    let productList = {};
    for (let id in state.products){
      if (state.products[id].inCart > 0){
        productList[id] = state.products[id];
      }
    }
    return productList;
  }, 
  getCartTotal: (state) => {
    let total = 0;
    for (let id in state.products){
      let value = state.products[id].price * state.products[id].inCart;
      if (Number.isNaN(value))
        console.log("value in cart not a number")
      else
        total += value;
    }
    return total;
  }, 
  getProductsOfType: (state) => (productType) => {
    let productList = [];
    for (let id in state.products){
      if (state.products[id].type === productType){
        productList.push(state.products[id]);
      }
    }
    return productList;
  }, 
  getProduct: (state) => (id) => {
    return state.products[id];
  }, 
}

 const mutations = {
    addProductAmount(state, {productId, addAmount}){
      state.products[productId].inCart += addAmount;
    }, 
    clearProductAmount(state, {productId}){
      state.products[productId].inCart = 0;
    }
 }

const actions = {
  sendAlert({getters}, {msg}){
    window.swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      title: msg,
    });
    // window.swal.fire('test!', "product added to cart", "success");
    console.log(getters.getProduct("1000").cnName);
  }, 
  addToCart({ dispatch, commit, getters }, {productId, addAmount}) {
    if (getters.getProduct(productId).inCart == 10 || getters.getProduct(productId).inCart0){
      console.log("too many or too little");
    }
    else{
      commit('addProductAmount', {productId, addAmount});
      if (addAmount > 0){
        dispatch("sendAlert", {
          msg: `${getters.getProduct(productId).cnName} added to cart`
        });
      }
    }
  }, 
  clearInCart({ dispatch, commit, getters }, {productId}) {
    commit('clearProductAmount', {productId});
    dispatch("sendAlert", {
      msg: `${getters.getProduct(productId).cnName} removed from cart`
    });
  }
}

export default{
  namespaced: true, 
  state, 
  getters, 
  actions, 
  mutations
}

